var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.styles.divider, { [_vm.styles.markers]: _vm.markers }]},[_c('div',{class:[_vm.styles.line, _vm.styles[_vm.type]]}),(_vm.text != null)?[_c('span',{class:_vm.styles.text},[_vm._v(_vm._s(_vm.text))]),_c('div',{class:[_vm.styles.line, _vm.styles[_vm.type]]})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }